<template>
  <div class="modal fade" id="remove-reminder" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" v-if="!message">
        <div class="block block-themed block-transparent">
          <div class="block-header" :class="headerColor">
            <h3 class="block-title">Delete reminder</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <h4>
              <center>Are you sure, you want to delete the Todo? <br/> This operation cannot be undone!</center>
            </h4>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="remove()" :disabled="showModalLoader">
              <div><span>Remove</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { helper } from '@/helper.js';
  import { mapActions } from 'vuex';
  import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
  Vue.use(VueSpinners);

  export default {
    name: 'RemoveReminder',
    data() {
      return {
        showModalLoader: false,
        selectedId: [],
        callback: null,
        errorMsg: '',
        headerColor: 'bg-warning'
      };
    },
    components: {
      HashLoader
    },
    methods: {
      ...mapActions('library', ['getRecentNotificationList', 'getRecentNotificationCount']),
      remove() {
        let vm = this;
        vm.showModalLoader = true;
        helper.sendPostRequest('/todo/update', {
          action: 'delete',
          selectedId: vm.selectedId
        }).then((data) => {
          if (data.status === 'success') {
            jQuery('#remove-reminder').modal('hide');
            vm.clearData();
            vm.getRecentNotificationList();
            vm.getRecentNotificationCount();
            vm.$emit('showSuccessMsg', data.message);
            vm.$emit('refreshList', true);
          } else {
            vm.errorMsg = data.message;
          }
        }).catch(function(e) {
          vm.errorMsg = 'Unable to process your request.';
        });
        vm.showModalLoader = false;
      },
      setSelectedId(selectedIds) {
        this.selectedId = selectedIds;
      },
      setCallback(callback) {
        this.callback = callback;
      },
      clearData() {
        this.showModalLoader = false;
        this.errorMsg = '';
        this.selectedId = [];
        if (this.callback !== null) {
          this.callback();
        }
      },
      setHeaderColor(color) {
        this.headerColor = color;
      }
    }
  }
</script>
<style scoped>
#remove-reminder .block {
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// source/components/modals/RemoveReminder.vue